/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useState, useEffect } from 'react'
import { useServiceContext } from '../../../../root'
import ModalConfirmation from '../../../../components/shared/ModalConfirmation'
import HtmlCell from '../../../../components/shared/HtmlCell'
import { toast } from '../../../../services/toast'
import { changeRequestTypesApiService } from '~/services/api/api.changerequesttypes'
import { Workflow } from '../../../../services/api'

interface ModalRemoveProps {
  template: Workflow
  onClose: () => void
  onSuccess?: () => void
}

const ModalRemove: React.FC<ModalRemoveProps> = ({ template, onClose, onSuccess }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter

  const [msg, setMsg] = useState<React.ReactNode>('')
  const [loading, setLoading] = useState<Promise<any> | null>(null)

  useEffect(() => {
    selectMessage()
  }, [])

  const selectMessage = async () => {
    try {
      setLoading(Promise.resolve())

      const textMsg = (
        <div>
          <HtmlCell>
            {template.name && template.name.length > 0
              ? translate('SETTINGS_WF_TEMPLATES_REMOVE_Q') + '<br/>' + '<b>' + template.name + '</b>'
              : translate('SETTINGS_TEMPLATES_CONFIRM_MSG1') + ' <b>' + template.name + '</b>'}
          </HtmlCell>
        </div>
      )

      setMsg(textMsg)
      setLoading(null)
    } catch (error) {
      console.error('Error loading template usage:', error)
      setLoading(null)
    }
  }

  const doSave = async () => {
    try {
      await changeRequestTypesApiService.remove(template.id)
      toast.success(translate('SETTINGS_WF_TEMPLATES_DELETE_SUCCESS_MSG'))

      if (onSuccess) {
        onSuccess()
      }
      onClose()
    } catch (error: any) {
      const errorMsg = error?.data?.message || error?.message || 'Unknown error'
      toast.error(translate('SETTINGS_WF_TEMPLATES_DELETE_FAIL_MSG') + ': ' + errorMsg)
    }
  }

  return (
    <ModalConfirmation
      titleMsg={translate('SETTINGS_CR_TYPES_DELETE_TITLE')}
      loading={loading}
      msg={msg}
      cancelTxt={translate('CANCEL')}
      okTxt={translate('OK')}
      onSubmit={doSave}
      onCancel={onClose}
    />
  )
}

export default ModalRemove
